import React from 'react';
import { PatternFormat } from 'react-number-format';
import PropTypes from 'prop-types';

import onUserValueChange from '~/components/core/Molecules/Fields/onUserValueChange';

function SocialSecurityNumberFormat(props) {
  const { inputRef, onChange, id, name, ...other } = props;

  return (
    <PatternFormat
      {...other}
      getInputRef={inputRef}
      onValueChange={onUserValueChange((values) => {
        onChange({
          target: {
            id,
            name,
            value: values.value,
          },
        });
      })}
      format="###-##-####"
      mask="_"
    />
  );
}

SocialSecurityNumberFormat.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default SocialSecurityNumberFormat;
